import React from "react";
import PageMeta from "../components/common/PageMeta";
import CategoryCards from "../components/home/CategoryCards";
import EditorialFeature from "../components/home/EditorialFeature";
import HomeHero from "../components/home/HomeHero";
import PantryCompanion from "../components/home/PantryCompanion";
import ProductRail from "../components/home/ProductRail";
import PromoMosaic from "../components/home/PromoMosaic";
import ReviewStrip from "../components/home/ReviewStrip";
import TrustStrip from "../components/home/TrustStrip";
import siteConfig from "../config/siteConfig";
import { productCategories, products } from "../data/products";
import recipes from "../data/recipes";

const HomePage = () => {
  const bestSellers = products
    .filter((product) => product.badges.includes("Best Seller"))
    .slice(0, 6);
  const rareFinds = products
    .filter((product) => product.category === "Rare Ingredients" || product.badges.includes("Rare Find"))
    .slice(0, 6);

  return (
    <>
      <PageMeta description={`Explore vivid small-batch spices, herbs, salts and hard-to-find pantry ingredients from ${siteConfig.displayName}.`} />
      <HomeHero />
      <TrustStrip />
      <PromoMosaic />
      <ProductRail
        dark
        eyebrow="The jars everyone reaches for"
        title="Most popular spices"
        description="Fresh, versatile pantry essentials chosen by thousands of curious cooks."
        products={bestSellers}
        href="/shop?collection=best-sellers"
      />
      <ProductRail
        eyebrow="For the adventurous shelf"
        title="Hard-to-find ingredients"
        description="Rare harvests and unexpected flavors, each with a clear path into your cooking."
        products={rareFinds}
        href="/collections/rare-ingredients"
      />
      <CategoryCards categories={productCategories} />
      <PantryCompanion />
      <EditorialFeature recipe={recipes[0]} />
      <ReviewStrip />
    </>
  );
};

export default HomePage;
